// Draws a small red dot over the current favicon (like Slack/Gmail's unread
// tab indicator) and restores the original icon when there's nothing new.
const BASE_TITLE = 'Deployment Management System';

function getFaviconLink(): HTMLLinkElement {
  let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  return link;
}

function drawBadge(image: HTMLImageElement | null): string {
  const size = 64;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return image?.src || '';

  if (image) {
    ctx.drawImage(image, 0, 0, size, size);
  }

  const radius = size * 0.26;
  const cx = size - radius - 2;
  const cy = radius + 2;
  ctx.beginPath();
  ctx.arc(cx, cy, radius, 0, Math.PI * 2);
  ctx.fillStyle = '#dc2626';
  ctx.fill();
  ctx.lineWidth = size * 0.05;
  ctx.strokeStyle = '#ffffff';
  ctx.stroke();

  return canvas.toDataURL('image/png');
}

export function setUnreadFaviconBadge(showBadge: boolean): void {
  const link = getFaviconLink();

  if (!link.dataset.originalHref) {
    link.dataset.originalHref = link.href;
  }

  if (!showBadge) {
    link.href = link.dataset.originalHref;
    return;
  }

  const img = new Image();
  img.onload = () => {
    link.href = drawBadge(img);
  };
  img.onerror = () => {
    // Original icon couldn't be loaded (e.g. missing file) — still show a
    // plain red dot rather than silently giving up on the indicator.
    link.href = drawBadge(null);
  };
  img.src = link.dataset.originalHref;
}

export function setUnreadTitle(count: number): void {
  document.title = count > 0 ? `(${count > 99 ? '99+' : count}) ${BASE_TITLE}` : BASE_TITLE;
}
